import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=36a46e99&scoped=true&class=content-notfound&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=36a46e99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a46e99",
  null
  
)

export default component.exports